import { defineComponent as t, openBlock as n, createBlock as l, unref as a, mergeProps as c, withCtx as p, createElementVNode as s } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconSparklesFilled",
  __name: "IconSparklesFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (d, e) => (n(), l(a(i), c(r, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        s("path", {
          "fill-rule": "evenodd",
          d: "M7.5 2.25A.75.75 0 0 1 8.25 3c0 1.506.324 2.389.85 2.911C9.627 6.435 10.51 6.75 12 6.75a.75.75 0 0 1 0 1.5c-1.483 0-2.37.323-2.898.852C8.572 9.63 8.25 10.517 8.25 12a.75.75 0 0 1-1.5 0c0-1.482-.325-2.369-.855-2.898C5.365 8.572 4.478 8.25 3 8.25a.75.75 0 0 1 0-1.5c1.483 0 2.369-.315 2.897-.84C6.424 5.389 6.75 4.505 6.75 3A.75.75 0 0 1 7.5 2.25m7.5 6A.75.75 0 0 1 15.75 9c0 1.884.47 3.16 1.28 3.97s2.086 1.28 3.97 1.28a.75.75 0 0 1 0 1.5c-1.884 0-3.16.47-3.97 1.28s-1.28 2.086-1.28 3.97a.75.75 0 0 1-1.5 0c0-1.884-.47-3.16-1.28-3.97S10.884 15.75 9 15.75a.75.75 0 0 1 0-1.5c1.884 0 3.16-.47 3.97-1.28s1.28-2.086 1.28-3.97A.75.75 0 0 1 15 8.25",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
